module.exports = __webpack_public_path__ + "img/syukyaku-top-g002.ac2764e7.png";